import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles(
  {
    root: {},
    input: {
      padding: [spacing.sp02, 0],
      display: 'flex',
      flexBasis: '100%',
      position: 'relative',
    },

    labelWrap: {
      display: 'flex',
      justifyContent: 'space-between',
    },

    label: {
      position: 'relative',
      color: colors.textSecondary,
    },

    withMinHeight: {
      minHeight: spacing.sp04,
    },

    invalid: {
      color: colors.textError,
    },

    disabled: {
      color: colors.textDisabled,
    },

    required: {
      '&:after': {
        content: '"*"',
        position: 'absolute',
        top: 0,
        right: -8,
        color: colors.iconError,
      },

      '$disabled&:after': {
        color: colors.iconDisabled,
      },
    },
  },
  {
    name: 'InputWrapper',
  },
);
